module.exports = __webpack_public_path__ + "img/alentour14.79afcae0.jpg";